import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../../styles/fontawesome-styles.css'
import './theme-colors.css'
import './theme-alerts.css'
import './theme-badges.css'
import './theme-buttons.css'
import './theme-cards.css'
import './theme-borders.css'
import './theme-navigation.css'
import './theme-backgrounds.css'
import './FontStyles.css'
import './ResearchBrandStyles.css'
import '../../../node_modules/react-bootstrap/dist/react-bootstrap.min.js'


const Layout = ({ children}) => {
   const { header, footer, sideMenu } = useStaticQuery(graphql`
    {
        header {
			html
		}
        footer {
			html
		}        
        sideMenu {
            html
        }
        
    }
   `)

    return (
        <>
            <header id="header" dangerouslySetInnerHTML={{ __html: header.html }}></header>
            <main id="main-content" className="container-fluid">
                <Row className="mb-3">
                    <Col lg={2} id="sidebar" className="px-0" dangerouslySetInnerHTML={{ __html: sideMenu.html }}/>
                    <Col lg={10} id="rightSide" className="mt-4">
                    {children}
                    </Col>
                </Row>
            </main>
            <footer id="footer" dangerouslySetInnerHTML={{ __html: footer.html }}></footer>
        </>
    )
}

export default Layout;